import React, { useState, useEffect, useRef } from "react";
import MoreMenu from "src/img/SubscriptionsMoreMenu.svg";
import { useHistory } from "react-router-dom";
import { SubscriptionStatus } from "src/components/SubscriptionElements";
import styled from "styled-components";

const MenuRoot = styled.div`
    position: relative;
    z-index: ${p => p.$open ? 20 : 1};
    display: flex;
    align-items: center;
`;

const MenuButton = styled.button`
    display: grid;
    place-items: center;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
`;

const MenuPopup = styled.div`
    position: absolute;
    z-index: 21;
    top: calc(100% + 0.5rem);
    right: 0;
    width: 220px;
    padding: 1rem;
    border: 1px solid #e9ebef;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0 12px 28px rgba(23, 26, 34, 0.18);
    color: #171a22;
    box-sizing: border-box;
    font-size: 14px;
    font-weight: 500;
    text-align: left;
`;

const MenuItem = styled.button`
    width: 100%;
    padding-top: ${p => p.$divided ? "0.5rem" : "0"};
    padding-bottom: ${p => p.$divided ? "0" : "0.5rem"};
    padding-left: 0;
    padding-right: 0;
    border-top: ${p => p.$divided ? "1px solid #e9ebef" : "0"};
    border-right: 0;
    border-bottom: 0;
    border-left: 0;
    background: transparent;
    color: inherit;
    font: inherit;
    text-align: left;
    cursor: pointer;
`;

function MoreMenuContainerSubscription({ cancelSubscriptionEvent, reactivationSubscriptionEvent, renewalSubscriptionEvent, status }) {
    const [hidden, setHidden] = useState(true);
    const menuRef = useRef(null);

    const handleClick = () => {
        setHidden(currentHidden => !currentHidden);
    };

    const handleCancelSubscription = () => {
        setHidden(true);
        cancelSubscriptionEvent(true);
    };

    const handleRenewalSubscription = () => {
        setHidden(true);
        renewalSubscriptionEvent(true);
    };

    const handleReactivationSubscription = () => {
        setHidden(true);
        reactivationSubscriptionEvent(true);
    };

    const history = useHistory();
    
    const handleUpdatePaymentMethod = () => {
        setHidden(true);
        history.push("/setting/payment");
    };
    
    const isActive = status === SubscriptionStatus.ACTIVE;
    const isCanceled = status === SubscriptionStatus.REACTIVATE;
    const isExpired = status === SubscriptionStatus.EXPIRED;

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setHidden(true);
            }
        };

        if (hidden === false) {
            document.addEventListener("click", handleClickOutside, true);
        }
        return () => {
            document.removeEventListener("click", handleClickOutside, true);
        };
    }, [hidden]);

    return (
        <MenuRoot ref={menuRef} $open={!hidden}>
            <MenuButton type="button" onClick={handleClick} aria-label="Subscription options" aria-expanded={!hidden}>
                <img src={MoreMenu} alt="" />
            </MenuButton>

            {!hidden && (
                <MenuPopup>
                    <MenuItem type="button" onClick={handleUpdatePaymentMethod}>Update Payment Method</MenuItem>
                    {isActive && <MenuItem type="button" $divided onClick={handleCancelSubscription}>Cancel Subscription</MenuItem>}
                    {isCanceled && <MenuItem type="button" $divided onClick={handleReactivationSubscription}>Reactivate Subscription</MenuItem>}
                    {isExpired && <MenuItem type="button" $divided onClick={handleRenewalSubscription}>Renew Subscription</MenuItem>}
                </MenuPopup>
            )}
        </MenuRoot>
    );
}

export default MoreMenuContainerSubscription;
